import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/services/auth.service';

@Component({
  selector: 'app-icon-transaction-source',
  templateUrl: './icon-transaction-source.component.html',
  styleUrls: ['./icon-transaction-source.component.sass']
})
export class IconTransactionSourceComponent implements OnInit {
  transactionSource = '';

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.authService.getAuthenticatedUser().subscribe((response: any) => {
      if (response) {
        this.transactionSource = response.program?.configuration?.main_source_transaction;
      }
    });
  }
}
